import React, { Fragment } from 'react';
import { RouteComponentProps } from 'react-router';
import { Box, Card, CardContent, Tab, Tabs } from '@material-ui/core';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import OrganizationDomains from './OrganizationDomains';
import OrganizationIntegrationApiLogs from './OrganizationIntegrationApiLogs';

interface IOrganizationWidgetState {
  selectedTab: number;
}

type IOrganizationWidgetProps = RouteComponentProps<{ id: string }>;

class OrganizationWidget extends React.PureComponent<
  IOrganizationWidgetProps,
  IOrganizationWidgetState
> {
  private translatorService!: ITranslatorService;

  static contextType = ApplicationContext;

  state = {
    selectedTab: 0
  } as IOrganizationWidgetState;

  handleTabChange = (event: React.ChangeEvent<unknown>, newValue: number) => {
    this.setState({ selectedTab: newValue });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;

    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <Card>
            <CardContent>
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                color="primary"
              >
                <Tab
                  className="text-capitalize"
                  label={this.translatorService.Tranlate(
                    'ORGANIZATIONS_TAB_DOMAINS',
                    'Domenii Widget'
                  )}
                />
                <Tab
                  className="text-capitalize"
                  label={this.translatorService.Tranlate('ORGANIZATION_WIDGET_TAB_LOGS', 'Loguri')}
                />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        {this.state.selectedTab === 0 ? <OrganizationDomains {...this.props} /> : null}
        {this.state.selectedTab === 1 ? <OrganizationIntegrationApiLogs {...this.props} /> : null}
      </Fragment>
    );
  }
}

export default OrganizationWidget;
